import gql from "graphql-tag";
import { partsStoreDetailsFields } from "./getPartsStore";

/**
 * Every part order on a job this technician is scheduled for in the given range.
 *
 * Deliberately not `getPartOrders`: that query caps at 10 results and takes a single
 * scalar job id, so it cannot answer "everything I need today". Grouping by store
 * happens client-side — the server returns a flat list.
 */
export const GET_MY_PART_ORDERS = gql`
  query getMyPartOrders($startRange: Date!, $endRange: Date!) {
    getMyPartOrders(startRange: $startRange, endRange: $endRange) {
      id
      orderNumber
      status
      notes
      partsLocation
      orderMethod
      partOrderingIssue
      partOrderingIssueNotes
      createdBy
      createdAt
      store {
        ${partsStoreDetailsFields}
      }
      job {
        id
        jobNumber
        isWithdrawn
        contact {
          id
        }
        appointment {
          id
          startDate
          endDate
          timeWindow {
            startTimeWindow
            endTimeWindow
          }
        }
        vehicleInfo {
          year
          make
          model
        }
      }
      items {
        id
        name
        partNumber
        units
        status
        pickedUpAt
        pickedUpBy
      }
    }
  }
`;
